import { connect } from 'react-redux';
import { actions } from "../../../../../../redux/modules/empresas/empresas";
import SucursalesEditar from './SucursalesEditar';


const ms2p = (state) => {
  return {
    ...state.empresas,
    empresa: state.empresas.editando
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(SucursalesEditar);
